import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AboutPage } from './components/AboutPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
        <Route path="/about" element={<AboutPage data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}